import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import logo from '../../imagens/logoInformezzAzul.svg';
import './Header.css';

const Header = ({ onContactClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Detectar scroll para adicionar estilo ao header
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fechar menu mobile ao redimensionar
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Scroll suave para seção
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 72; // Altura aproximada do header
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Main Header */}
      <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
        <div className="container">
          <div className="header__content">
            {/* Logo */}
            <div className="header__logo" onClick={() => navigate('/')}>
              <img src={logo} alt="Informezz Sistemas" />
            </div>

            {/* Desktop Navigation */}
            <nav className="header__nav">
              <button 
                className="header__nav-link"
                onClick={() => scrollToSection('funcionalidades')}
              >
                Funcionalidades
              </button>
              <button 
                className="header__nav-link"
                onClick={() => scrollToSection('sobre-nos')}
              >
                Sobre Nós
              </button>
              <button 
                className="header__nav-link"
                onClick={() => scrollToSection('contato')}
              >
                Contato
              </button>
            </nav>

            {/* CTA Buttons */}
            <div className="header__actions">
              <a
                href="https://wa.me/5546991107619?text=Olá! Gostaria de saber mais sobre o sistema."
                target="_blank"
                rel="noopener noreferrer"
                className="header__whatsapp-cta"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                <span>Fale com um especialista</span>
              </a>
              <div className="header__social-group">
                <a
                  href="https://www.instagram.com/informezz/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header__social-btn"
                  aria-label="Instagram"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a
                  href="https://www.facebook.com/people/Informezz-Sistemas/61557268662997/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header__social-btn"
                  aria-label="Facebook"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
              </div>
            </div>

            {/* Mobile Menu Toggle */}
            <button 
              className="header__mobile-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
            >
              <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`header__mobile-menu ${isMobileMenuOpen ? 'header__mobile-menu--open' : ''}`}>
          <nav className="header__mobile-nav">
            <button 
              className="header__mobile-nav-link"
              onClick={() => scrollToSection('funcionalidades')}
            >
              Funcionalidades
            </button>
            <button 
              className="header__mobile-nav-link"
              onClick={() => scrollToSection('sobre-nos')}
            >
              Sobre Nós
            </button>
            <button 
              className="header__mobile-nav-link"
              onClick={() => scrollToSection('contato')}
            >
              Contato
            </button>
          </nav>
          <div className="header__mobile-actions">
            <a
              href="https://wa.me/5546991107619?text=Olá! Gostaria de saber mais sobre o sistema."
              target="_blank"
              rel="noopener noreferrer"
              className="header__whatsapp-cta header__whatsapp-cta--full"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>Fale pelo WhatsApp</span>
            </a>
          </div>
        </div>
      </header>

      {/* Overlay para mobile menu */}
      {isMobileMenuOpen && (
        <div 
          className="header__overlay"
          onClick={toggleMobileMenu}
        />
      )}
    </>
  );
};

export default Header;
